import {

	_allProgramsDataSuccess,
	_getTutorData,
	_setProgramName,
	_setAttendanceData,
	_postAttendance,
	_getAllChaptersOfProgram,
	_getTopicsFortheChapters,
	_addTopic,
	_getPlanners,
	_getClassStartTime

} from '../actions/types';

const initialState = {

	allProgramsData: '',
	tutorData: [],
	programName: '',
	attendanceData: [],
	chaptersData: '',
	topicsData: '',
	afterTopicsData: '',
	allPlanners: '',
	classStartTime: ''
};

export default function (state = initialState, action) {
	switch (action.type) {

		case _allProgramsDataSuccess:
			return {
				...state,
				allProgramsData: action.payload
			};

		case _getTutorData:
			return {
				...state,
				tutorData: action.payload
			}
		case _setProgramName:
			return {
				...state,
				programName: action.payload
			}
		case _setAttendanceData:
			return {
				...state,
				attendanceData: action.payload
			}
		case _postAttendance:
			var rv = {};
			var evaluation = {};
			for (var i = 0; i < action.payload.attendance_data.length; ++i) {
				rv[action.payload.attendance_data[i].student_id] = action.payload.attendance_data[i];
				evaluation[action.payload.attendance_data[i].student_id] = null;
			}
			var teacher_students = {
				[`${action.payload.prog_id}||${action.payload.slot_id}`]: rv,
				...state.attendanceData.teacher_students
			}
			// var teacher_students = {
			// 	[action.payload.prog_id]: rv,
			// 	...state.attendanceData.teacher_students
			// }
			var evaluation_data = {
				[`${action.payload.prog_id}||${action.payload.slot_id}`]: evaluation,
				...state.attendanceData.evaluation_data
			}
			// var evaluation_data = {
			// 	[action.payload.prog_id]: evaluation,
			// 	...state.attendanceData.evaluation_data
			// }
			console.log(rv);
			console.log(evaluation);
			console.log(teacher_students);
			var toAdd = { teacher_students };
			var toEvaluate = { evaluation_data };

			console.log("To Submit", toAdd);
			return {
				...state,
				attendanceData: {
					...state.attendanceData,
					...toAdd,
					...toEvaluate
				}

			}

		case _getAllChaptersOfProgram:
			return {
				...state,
				chaptersData: action.payload
			}

		case _getTopicsFortheChapters:
			debugger;
			return {
				...state,
				topicsData: { ...state.topicsData, ...action.payload }
			}
		case _addTopic:
			debugger;
			var newTopic = [];
			var obj = {
				[action.payload.testid]: {}
			}
			if (Object.keys(state.topicsData).length === 0) {
				var newObj = {
					[action.id]: {
						"topics": [action.payload]
					}
				}
				state.topicsData = { ...newObj };
				debugger;
			}
			else if (typeof state.topicsData[action.id] === "undefined") {
				debugger;
				var newObj = {
					[action.id]: {
						"topics": [action.payload]
					}
				}
				state.topicsData = { ...newObj };
			}
			else {
				debugger;
				state.topicsData[action.id]['topics'] = [...state.topicsData[action.id]['topics'], { ...action.payload }];
				state.topicsData[action.id]['topicData'] = { ...state.topicsData[action.id]['topicData'], ...obj };
			}
			console.log("NEW STATE", state.topicsData);
			console.log("New Obj", obj);
			debugger;
			return {
				...state,
				afterTopicsData: { ...state.topicsData }
			}

		case _getPlanners:
			return {
				...state,
				allPlanners: action.payload
			}
		case _getClassStartTime:
			return {
				...state,
				classStartTime: action.payload
			}
		default:
			return state;

	}
}
